/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FirstName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function FirstName({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Form/Fields/FirstName",
  isInvalid,
  onChange
  
}) {
let newPatientPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'new_patient',
path: 'person.first_name',
})
let newPatientPersonFirstNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_patient',
path: 'person.first_name',
validate: fromValidate.name,
required: true,
})
let newPatientPersonFirstNameChangeData = fromData.useDataChange({ viewPath,
context: 'new_patient',
path: 'person.first_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="new_patient.person.first_name"
 validate="/Data/validate.js name"
 required={true}
 invalid={!newPatientPersonFirstNameIsValidData}
 value={newPatientPersonFirstNameValueData}
 onChange={newPatientPersonFirstNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="First Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}